import { expandSlots } from './schedule.js';
/** 케어 루틴은 투약과 같은 결정론적 슬롯 전개를 사용한다. */
export function expandRoutineSlots(routine, timeZone, from, to) {
    return expandSlots(routine, timeZone, from, to);
}
